import { Badge, BadgeVariant } from '@/components/ui/Badge'
import { StandardDonationAasmState } from '@types'

export type StatusBadgeStatus =
  | 'dispatch'
  | 'return'
  | StandardDonationAasmState

interface StatusBadgeProps {
  status: StatusBadgeStatus
  className?: string
  testId?: string
}

interface StatusConfig {
  label: string
  icon?: string
  variant: BadgeVariant
}

const getStatusConfig = (status: StatusBadgeStatus): StatusConfig => {
  switch (status) {
    case 'dispatch':
      return {
        label: 'Dispatch Location',
        icon: 'play',
        variant: 'default',
      }
    case 'return':
      return {
        label: 'Return Location',
        icon: 'play',
        variant: 'default',
      }
    case StandardDonationAasmState.ENQUEUED:
      return {
        label: 'In Review',
        variant: 'warning',
      }
    case StandardDonationAasmState.ACCEPTED:
      return {
        label: 'Accepted',
        variant: 'primary',
      }
    case StandardDonationAasmState.EN_ROUTED:
      return {
        label: 'En Route',
        variant: 'info',
      }
    case StandardDonationAasmState.ARRIVED:
      return {
        label: 'Arrived',
        variant: 'success',
      }
    case StandardDonationAasmState.COMPLETED:
      return {
        label: 'Completed',
        icon: 'check-double',
        variant: 'solid-success',
      }
    case StandardDonationAasmState.CANCELED:
      return {
        label: 'Canceled',
        icon: 'x',
        variant: 'solid-error',
      }
    case StandardDonationAasmState.DECLINED:
      return {
        label: 'Declined',
        icon: 'x',
        variant: 'solid-error',
      }
    default:
      return {
        label: 'In Review',
        variant: 'warning',
      }
  }
}

export const StatusBadge = ({
  status,
  className = '',
  testId,
}: StatusBadgeProps) => {
  const config = getStatusConfig(status)

  return (
    <Badge
      text={config.label}
      variant={config.variant}
      icon={config.icon}
      className={className}
      testId={testId || `status-badge-${status}`}
    />
  )
}
